import { usePermission } from './usePermission';

export default function Can({ perm, any, children }) {
  const { can, canAny } = usePermission();
  const allowed = any ? canAny(any) : can(perm);
  return allowed ? children : null;
}
